

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoVeSinhNuocSach} from "@/models/baoCaoVeSinhNuocSach";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoThongKeTiemVacxin} from "@/models/baoCaoThongKeTiemVacxin";
import {BaoCaoTinhHinhSDVacxinVaDCTC} from "@/models/baoCaoTinhHinhSDVacxinVaDCTC";
import {BaoCaoSangLocBenhKLN} from "@/models/baoCaoSangLocBenhKLN";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoSangLocBenhKLN);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const team = computed(() => store.state.team);
    const initDb = () => {
      baoCao.value.baoCaos = [
        {tenDonVi: store.state.team},
      ];
    }
    initDb();

    const addReport = () => {
      if(baoCao.value.tuThang == null || baoCao.value.denThang == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoSangLocBenh(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoSangLocBenhKLN);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }


    // const totalVacxin = (id) => {
    //   let total = 0;
    //   if(id == 1) {
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.nam != null)
    //         total += a.nam;
    //     }
    //   }
    //   else if(id == 2){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.nu != null)
    //         total += a.nu;
    //     }
    //   }
    //   else if(id == 3){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.duoi15Tuoi != null)
    //         total += a.duoi15Tuoi;
    //     }
    //   }
    //   else if(id == 4){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tu15Den24Tuoi != null)
    //         total += a.tu15Den24Tuoi;
    //     }
    //   }
    //   else if(id == 5){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tu25Den49Tuoi != null)
    //         total += a.tu25Den49Tuoi;
    //     }
    //   }
    //   else if(id == 6){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tren50Tuoi != null)
    //         total += a.tren50Tuoi;
    //     }
    //   }
    //   else if(id == 7){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.duoi10Ngay != null)
    //         total += a.duoi10Ngay;
    //     }
    //   }
    //   else if(id == 8){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tren10Ngay != null)
    //         total += a.tren10Ngay;
    //     }
    //   }
    //   else if(id == 9){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.cho != null)
    //         total += a.cho;
    //     }
    //   }else if(id == 10){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.meo != null)
    //         total += a.meo;
    //     }
    //   }else if(id == 11){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.doi != null)
    //         total += a.doi;
    //     }
    //   }else if(id == 12){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.khac != null)
    //         total += a.khac;
    //     }
    //   }else if(id == 13){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.dauMatCo != null)
    //         total += a.dauMatCo;
    //     }
    //   }else if(id == 14){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.than != null)
    //         total += a.than;
    //     }
    //   }else if(id == 15){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tay != null)
    //         total += a.tay;
    //     }
    //   }else if(id == 16){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.chan != null)
    //         total += a.chan;
    //     }
    //   }else if(id == 17){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.doI != null)
    //         total += a.doI;
    //     }
    //   }else if(id == 18){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.doII != null)
    //         total += a.doII;
    //     }
    //   }else if(id == 19){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.doIII != null)
    //         total += a.doIII;
    //     }
    //   }else if(id == 20){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.binhThuong != null)
    //         total += a.binhThuong;
    //     }
    //   }else if(id == 21){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.om != null)
    //         total += a.om;
    //     }
    //   }else if(id == 22){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.chayRong != null)
    //         total += a.chayRong;
    //     }
    //   }else if(id == 23){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.lenConDai != null)
    //         total += a.lenConDai;
    //     }
    //   }else if(id == 24){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tiemTrongDa != null)
    //         total += a.tiemTrongDa;
    //     }
    //   }else if(id == 25){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tiemBap != null)
    //         total += a.tiemBap;
    //     }
    //   }else if(id == 26){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.soNguoiDungHTKD != null)
    //         total += a.soNguoiDungHTKD;
    //     }
    //   }else if(id == 27){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.dau != null)
    //         total += a.dau;
    //     }
    //   }else if(id == 28){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.quanDo != null)
    //         total += a.quanDo;
    //     }
    //   }else if(id == 29){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.tuMau != null)
    //         total += a.tuMau;
    //     }
    //   }else if(id == 30){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.phuNe != null)
    //         total += a.phuNe;
    //     }
    //   }else if(id == 31){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.sot != null)
    //         total += a.sot;
    //     }
    //   }else if(id == 32){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.khoChiu != null)
    //         total += a.khoChiu;
    //     }
    //   }else if(id == 33){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.nguaManDo != null)
    //         total += a.nguaManDo;
    //     }
    //   }else if(id == 34){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.dauCo != null)
    //         total += a.dauCo;
    //     }
    //   }else if(id == 35){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.roiLoanTieuHoa != null)
    //         total += a.roiLoanTieuHoa;
    //     }
    //   }else if(id == 36){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.khacToanThan != null)
    //         total += a.khacToanThan;
    //     }
    //   }else if(id == 37){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.coTiem != null)
    //         total += a.coTiem;
    //     }
    //   }else if(id == 38){
    //     for (let a of baoCao.value.baoCaos) {
    //       if (a.khongTiem != null)
    //         total += a.khongTiem;
    //     }
    //   }
    //
    //   if(total == 0) {
    //     return "";
    //   }
    //   else {
    //     return total;
    //   }
    // };

    return {
      date,
      service,
      addReport,
      baoCao,
      // totalVacxin,
      // addHoSo
    }
  }

}
